import AuditLogPage from "auditlog/AuditLogPage";
import AuditLogConfigurationPage from "auditlog/AuditLogConfigurationPage";
import { CONFIGURATION_NAV_TITLE } from "common/Constants";
import AuditLogRoutes from "./Routes";
export const PAGE_NAV_TITLE = "Audit Log";
const pluginExports = {
  routes: [
    { path: AuditLogRoutes.unqualified.LIST, component: AuditLogPage },
    { path: AuditLogRoutes.unqualified.CONFIGURATION, component: AuditLogConfigurationPage }
  ],
  pageNavigation: [
    {
      description: PAGE_NAV_TITLE,
      children: [
        {
          description: "Overview",
          titleKey: "enterprise_navigation:audit_log.overview",
          path: AuditLogRoutes.LIST,
          exactPathMatch: true
        },
        {
          description: CONFIGURATION_NAV_TITLE,
          titleKey: "enterprise_navigation:audit_log.configuration",
          path: AuditLogRoutes.CONFIGURATION,
          permissions: "eventdefinitions:read"
        }
      ]
    }
  ]
};
export default pluginExports;
